/**
 * Correo Horus en sessionStorage para consultas de storefront sin login Shopify.
 */
(function (global) {
  const EMAIL_KEY = 'horus_login_email_hint';
  const ENTRY_KEY = 'horus_entry_active';
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+(\.[^\s@]+)*$/;

  function normalizeEmail(raw) {
    if (!raw) return null;
    const value = String(raw).trim().toLowerCase();
    return EMAIL_PATTERN.test(value) ? value : null;
  }

  function horusContactEmail() {
    try {
      if (sessionStorage.getItem(ENTRY_KEY) !== '1') return null;
      return normalizeEmail(sessionStorage.getItem(EMAIL_KEY));
    } catch (_) {
      return null;
    }
  }

  function canQueryStorefrontCustomer(customerLoggedIn) {
    return customerLoggedIn === 'true' || Boolean(horusContactEmail());
  }

  global.HorusStorefrontContact = {
    email: horusContactEmail,
    canQuery: canQueryStorefrontCustomer,
  };
})(window);
